import moment from 'moment'
import { Calendar } from 'primereact/calendar'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import editIcon from '../../assets/images/edit.png'
import calendarIcon from '../../assets/images/Calendar.svg'
import { ALLOWABLE_BOOKING_DATE } from '../../configs/appConfigs'
import { getFormattedNumber, getWeightUnit } from '../../constants'
import { getBase64Encoded, setToSessionStorage } from '../../utils/StorageUtils'
import './shipment-summary.scss'

const ShipmentSummary = ({ searchFormData, setSeachFormData }) => {
	const { origin, destination, shippingDate } = searchFormData
	const history = useHistory()

	//for multilingual
	const { t, i18n } = useTranslation(['labels', 'errors'])

	const goToHome = (e) => {
		if (searchFormData.isModifyBooking && searchFormData.awbNo) {
			history.push({
				pathname: `/booking/modify/${searchFormData.awbNo}`,
				state: {
					isBackButtonAction: true,
				},
			})
		} else {
			history.push('/booking/search')
		}
	}

	const [selectedShippingDate, setShippingDate] = useState(
		moment(shippingDate).toDate()
	)

	useEffect(() => {
		if (searchFormData) {
			setShippingDate(moment(shippingDate, 'DD-MMM-YYYY').toDate())
		}

	}, [searchFormData])

	const handleDateChange = (date) => {
		setShippingDate(date)
		const updatedSearchFormData = {
			...searchFormData,
			orginalShipingDate: moment(date).format('DD-MMM-YYYY'),
			shippingDate: moment(date).format('DD-MMM-YYYY'),
		}
		setToSessionStorage('searchObject', getBase64Encoded(updatedSearchFormData))
		setSeachFormData(updatedSearchFormData)
	}

	const getPetsSum = (cages) => {
		let petList = cages.map((item) => {
			return item.pets.length
		})
		let sum = 0;
		for (const item of petList) {
			sum += item;
		}
		if (sum > 1) {
			return sum + ' Pets';
		}
		else {
			return sum + ' Pet';
		}
	}

	const getCageString = (length) => {
		let cageString = length > 1 ? 'Containers' : 'Container'
		return cageString;
	}

	return (
		<div className='shipment-summary'>
			{/* Desktop View */}
			<div className='d-none d-lg-flex align-items-center flex-fill shipment-summary-details-row'>
				<div className='shipment-summary__item'>
					<div className='shipmment-origin-destination'>
						<label className='summary-details-heading'>{t('CHOOSE_FLT.ORGIN_DESTINATION')}</label>
						{origin && destination && (
							<span>{`${origin.code}-${destination.code}`}</span>
						)}
						{!origin && !destination && <span>{`${origin}-${destination}`}</span>}
					</div>
				</div>
				<div className='shipment-summary__separator'></div>

				<div className='shipment-summary__item border-r-0 calender-icon mr-2'>
					<div className='shipmment-origin-destination'>
						<label className='summary-details-heading'>{t('COMMON.SHP_DATE')}</label>
						{shippingDate
							? moment(selectedShippingDate, 'DD-MMM-YYYY').format('ddd Do MMM')
							: ''}
					</div>
				</div>
				<div className='shipment-summary__separator'></div>

				<div className='shipment-summary__item'>
					<label className='summary-details-heading'>{t('COMMON.CARGO_DTLS')}</label><br />
					{searchFormData.shippingItemCode?.code}
					{' - '}
					{searchFormData.shippingItemCode?.product}
				</div>

				<div className='shipment-summary__separator'></div>

				<div className='shipment-summary__item'>
					<label className='summary-details-heading'>{t('COMMON.PCS')}</label><br />
					{searchFormData.shippingItemCode &&
						(searchFormData.shippingItemCode.code === "DOG" || searchFormData.shippingItemCode.code === "CAT"
							? searchFormData.crates && searchFormData.crates[0]?.weight
								? `${getPetsSum(searchFormData.crates)} in ${searchFormData.crates.length} ${getCageString(searchFormData.crates.length)}`
								: ''
							: getFormattedNumber(searchFormData.totalPieces)
						)
					}
				</div>
				<div className='shipment-summary__separator'></div>

				<div className='shipment-summary__item border-r-0'>
					<label className='summary-details-heading'>{t('COMMON.GROSS_WT')}</label><br />
					{searchFormData.grossWeightInSelectedUnit}
					{getWeightUnit(searchFormData.weightUnit)}
				</div>

				<div className='shipment-summary__item__right'>
					<div className='l-link d-none d-md-block d-lg-block' onClick={goToHome}>
						<span>{t('COMMON.EDIT')}</span>
					</div>
				</div>
			</div>

			{/* Mobile View */}
			<div className='shipment-summary__mobile d-lg-none'>
					<div className='shipment-summary__item'>
						<div className='shipmment-origin-destination'>
							<label className='summary-details-heading'>{t('CHOOSE_FLT.ORGIN_DESTINATION')}</label>
							{origin && destination && (
								<span>{`${origin.code}-${destination.code}`}</span>
							)}
							{!origin && !destination && <span>{`${origin}-${destination}`}</span>}
						</div>
					</div>
					<div className='shipment-summary__item border-r-0 calender-icon mr-2'>
						<div className='shipmment-origin-destination'>
							<label className='summary-details-heading'>{t('COMMON.SHP_DATE')}</label>
							{shippingDate
								? moment(selectedShippingDate, 'DD-MMM-YYYY').format('ddd Do MMM')
								: ''}
						</div>
					</div>
					<div className='shipment-summary__item'>
						<label className='summary-details-heading'>{t('COMMON.PCS')}</label><br />
					{searchFormData.shippingItemCode &&
						(searchFormData.shippingItemCode.code === "DOG" || searchFormData.shippingItemCode.code === "CAT"
							? searchFormData.crates && searchFormData.crates[0]?.weight
								? `${getPetsSum(searchFormData.crates)} in ${searchFormData.crates.length} ${getCageString(searchFormData.crates.length)}`
								: ''
							: getFormattedNumber(searchFormData.totalPieces)
						)
					}
					</div>
					<div className='shipment-summary__item__right'>
						<a className='l-link' onClick={goToHome}>
							<span>{t('COMMON.EDIT')}</span>
						</a>
					</div>
			</div>
		</div>
	)
}

export default ShipmentSummary
